module.exports = __webpack_public_path__ + "img/logo.103d6fe6.svg";